import { useSetRecoilState } from 'recoil';
import { advertiserAtom } from '@/recoil/atoms/advertiger.atom';
import axiosRequest from '@/api';
import { AdvertiserResponse } from '@/@types/AdvertiserData';
import { ResData } from '@/@types';

const useFetchAdvertisers = () => {
  const setAdvertisers = useSetRecoilState(advertiserAtom);

  const fetchAdvertisers = async () => {
    try {
      const response = await axiosRequest.requestAxios<ResData<AdvertiserResponse>>('get', '/advertiser');

      const advertisers = response.data.result.map(ad => ({
        key: ad.key,
        number: ad.number,
        name: ad.name,
        status: ad.status,
        manager_name: ad.manager_name,
        manager_tel: ad.manager_tel,
        manager_email: ad.manager_email,
        id: ad.id,
      }));

      setAdvertisers(advertisers);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  };
  return fetchAdvertisers;
};

export default useFetchAdvertisers;
